import React, { useState, useContext, useEffect } from "react";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import ChangePassword from "./ChangePassword";
import { Link } from "react-router-dom";
import BVN from "./BVN";
import { UserContext } from "../../Context/UserContext";
import getServices from "../../Services/get-service";
import Skeleton from "@mui/material/Skeleton";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import IdentityDocModal from "./IdentityDocModal";
import DeleteAccountModal from "./DeleteAccountModal";

function Security() {
  const { userDetails } = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [open1, setOpen1] = useState(false);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);
  const [identityModalOpen, setIdentityModalOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);

  const [kycData, setKycData] = useState(null);
  const [loadingKyc, setLoadingKyc] = useState(true);
  const [identityStatus, setIdentityStatus] = useState("Verify Now"); // or 'Under review'

  const maskBvn = (bvn) => {
    if (!bvn) return "******";
    const strBvn = String(bvn);
    return strBvn.slice(0, 4) + "*".repeat(Math.max(0, strBvn.length - 4));
  };

    useEffect(() => {
      getServices
        .getUserKycLevel()
        .then((res) => {
          if (res.data && res.data.statusCode === 200) {
            setKycData(res.data.data);
          }
          setLoadingKyc(false);
        })
        .catch((err) => {
          console.error("Error fetching KYC level", err);
          setLoadingKyc(false);
        });
    }, []);

  return (
    <div>
      <ChangePassword open={open} handleClose={handleClose} />
      <BVN open={open1} handleClose={handleClose1} />
      <IdentityDocModal
        open={identityModalOpen}
        handleClose={() => setIdentityModalOpen(false)}
        setIdentityStatus={setIdentityStatus}
      />
      <DeleteAccountModal
        open={deleteModalOpen}
        handleClose={() => setDeleteModalOpen(false)}
      />

      <div className="mb-10">
        <p className="text-[#1C1B1F] font-semibold mb-2 text-[16px] md:text-xl">
          Verification Details
        </p>
        <p className="text-[#79747E] text-[14px] mb-6">
          Verify your identity to unlock investments, fund your wallet, and
          withdraw earnings securely
        </p>

        <div className="border border-[#E6E6E6] rounded-[16px] bg-white p-6">
          {/* BVN Section */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="bg-[#F4F4F4] p-3 rounded-full flex items-center justify-center">
                <LockOutlinedIcon className="text-[#79747E]" fontSize="small" />
              </div>
              <div>
                <p className="text-[#1C1B1F] font-semibold text-[16px] mb-1">
                  BVN Verification
                </p>
                <p className="text-[#79747E] text-[14px]">
                  {maskBvn(userDetails?.bvn)}
                </p>
              </div>
            </div>
            <div>
              {loadingKyc ? (
                <Skeleton
                  variant="rounded"
                  width={80}
                  height={35}
                  sx={{ borderRadius: "8px" }}
                />
              ) : kycData?.bvnVerified ? (
                <span className="bg-[#CCF2E1] text-[#008A56] px-6 py-2 rounded-md text-[14px] font-medium">
                  Verified
                </span>
              ) : (
                <button
                  onClick={handleOpen1}
                  className="bg-[#00B172] text-[#ffffff] px-6 py-2 rounded-md text-[14px] font-medium"
                >
                  Verify Now
                </button>
              )}
            </div>
          </div>

          <div className="border-t border-[#E6E6E6] my-6"></div>

          {/* Identity Section */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="bg-[#F4F4F4] p-3 rounded-full flex items-center justify-center">
                <LockOutlinedIcon className="text-[#79747E]" fontSize="small" />
              </div>
              <div>
                <p className="text-[#1C1B1F] font-semibold text-[16px] mb-1">
                  Identity Verification
                </p>
                <p className="text-[#79747E] text-[14px]">
                  Verify your identity to unlock investments limits
                </p>
              </div>
            </div>
            <div>
              {loadingKyc ? (
                <Skeleton
                  variant="rounded"
                  width={100}
                  height={40}
                  sx={{ borderRadius: "8px" }}
                />
              ) : kycData?.identityVerified ? (
                <span className="bg-[#CCF2E1] text-[#008A56] px-6 py-2 rounded-md text-[14px] font-medium">
                  Verified
                </span>
              ) : identityStatus === "Under review" ? (
                <span className="bg-[#FFF4D2] text-[#B59124] px-6 py-2 rounded-md text-[14px] font-medium">
                  Under review
                </span>
              ) : (
                <button
                  onClick={() => setIdentityModalOpen(true)}
                  className="bg-[#00B172] text-white px-6 py-2 rounded-md text-[14px] font-medium hover:bg-[#009b63] transition-colors"
                >
                  Verify Now
                </button>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="mb-10">
        <p className="text-[#1C1B1F] font-semibold mb-2 text-[16px] md:text-xl">
          Password & Pin
        </p>
        <p className="text-[#79747E] text-[14px] mb-6">
          Change password and pin.
        </p>

        <div className="border border-[#E6E6E6] rounded-[16px] bg-white p-6">
          {/* Password Section */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="bg-[#F4F4F4] p-3 rounded-full flex items-center justify-center">
                <LockOutlinedIcon className="text-[#79747E]" fontSize="small" />
              </div>
              <div>
                <p className="text-[#1C1B1F] font-semibold text-[16px] mb-1">
                  Password
                </p>
                {/* <p className='text-[#79747E] text-[14px]'>Last updated 2 months ago</p> */}
              </div>
            </div>
            <div>
              <button
                onClick={handleOpen}
                className="border border-[#E6E6E6] text-[#00B172] px-6 py-2 rounded-[8px] text-[14px] font-medium hover:bg-[#F4F4F4] transition-colors"
              >
                Change
              </button>
            </div>
          </div>

          <div className="border-t border-[#E6E6E6] my-6"></div>

          {/* Pin Section */}
          <div className="flex justify-between items-center">
            <div className="flex items-center gap-4">
              <div className="bg-[#F4F4F4] p-3 rounded-full flex items-center justify-center">
                <LockOutlinedIcon className="text-[#79747E]" fontSize="small" />
              </div>
              <div>
                <p className="text-[#1C1B1F] font-semibold text-[16px] mb-1">
                  Pin
                </p>
                {/* <p className='text-[#79747E] text-[14px]'>Last updated 3 months ago</p> */}
              </div>
            </div>
            <div>
              <Link
                to="changepin/current"
                className="border border-[#E6E6E6] text-[#00B172] px-6 py-2.5 rounded-[8px] text-[14px] font-medium hover:bg-[#F4F4F4] transition-colors inline-block"
              >
                Change
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Delete account request*/}
      <div className="mb-10">
        <p className="text-[#1C1B1F] font-semibold mb-2 text-[16px] md:text-xl">
          Delete account request
        </p>
        <div className="border border-[#E6E6E6] rounded-[16px] bg-white p-6">
          <button
            onClick={() => setDeleteModalOpen(true)}
            className="bg-[#FFDEDE] text-[#FF5959] w-[20%] px-6 py-3 rounded-[8px] text-[14px] font-bold"
          >
            Delete Account
          </button>
        </div>
      </div>
    </div>
  );
}

export default Security;
